var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92871 19.0713C3.11907 17.2616 2 14.7614 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.9493 20.7224 17.5994 18.6914 19.4297C18.9395 19.2061 19.1767 18.9708 19.4014 18.7236C18.1619 15.6507 15.3152 13.5 11.999 13.5C8.68349 13.5001 5.83641 15.6496 4.59668 18.7217C4.71112 18.8476 4.82857 18.9708 4.94922 19.0908L4.92871 19.0713ZM12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6ZM6.08789 20.0635C5.96336 19.972 5.84075 19.8782 5.7207 19.7812C5.84073 19.8782 5.96338 19.972 6.08789 20.0635ZM5.30859 19.4307C5.18607 19.3203 5.06614 19.2071 4.94922 19.0908C5.06613 19.2071 5.18609 19.3203 5.30859 19.4307Z",
    fill: "#A4ACB8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#A4ACB8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24User);
export default __webpack_public_path__ + "static/media/24_User.de73e312692c8779693f60fbfb5d3f44.svg";
export { ForwardRef as ReactComponent };